export const MIN_STRING_LENGTH = 1
export const MAX_TITLE_LENGTH = 100

export const MIN_ITEMS_QUANTITY = 1

export const ALLOWED_SYMBOLS_REGEX = /^[a-zA-Z0-9' _-]*$/;

export const MOBILE_SERVICE_TYPES = {
    features: 1,
    widgets: 2
}

export const SERVICE_TO_WIDGET_AND_FEATURE = {
  "Nutrition programs": ["Nutrition Programs"],
  "Fitness programs": ["Fitness Programs"],
  "Wellness programs": ["Wellness Programs"],
  "Content": ["Explore Content"],
  "Blood biomarkers": ["Lab Results"],
  "Mind and Body": ["Mind & Body", "MirrorMirror Mind", "MirrorMirror Body"],
  "MirrorMirror": ["MirrorMirror"],
  "Connected devices": ["Device Data"]
};

export const SERVICE_FEATURE_NAME = {
    mirrorMirror: "MirrorMirror",
}

export const BOTTOM_NAV_ELEMENTS = {
    exploreContent: 9,
    nutritionProgram: 10,
    fitnessProgram: 11,
    wellnessProgram: 12,
    lifeStyleDashboard: 13,
    mirrorMirror: 14,
    mindAndBody: 15,
    labResults: 16,
    menu: 0
}

export const MOBILE_WIDGET_IDS = {
    dailyProgress: 25,
    waterIntake: 26,
    deviceData: 27,
    mirrorMirrorMind: 28,
    mirrorMirrorBody: 29,
    mood: 30,
    fasting: 31,
    womenCycle: 46
}

export const fontOptions = [
    { label: "Neue Montreal", value: "NeueMontreal" },
    { label: "Roboto", value: "Roboto" },
    { label: "Inter", value: "Inter" },
    { label: "Lato", value: "Lato" },
    { label: "Open Sans", value: "OpenSans" }
];

export const fontClassMap = {
    "NeueMontreal": "font-neue-montreal",
    "Roboto": "font-roboto",
    "Inter": "font-inter",
    "Lato": "font-lato",
    "OpenSans": "font-open-sans"
};

export const SECTION = {
    SPLASH: "splash",
    SIGNIN: "signin",
    FONTFAMILY: "fontFamily",
    WIDGETS: "widgets",
    FEATURES: "features"
};

export const SECTION_TO_SLIDE_INDEX = {
    [SECTION.SPLASH]: 0,
    [SECTION.SIGNIN]: 1,
    [SECTION.FONTFAMILY]: 1,
    [SECTION.WIDGETS]: 2,
    [SECTION.FEATURES]: 2
};
